import { motion } from 'framer-motion';
import styled from 'styled-components';

import { floorGameColor as color, styledTypography } from '@pkg/primitives';

import {
    pocketBackgroundVariants,
    pocketContentVariants,
    pocketCountTransition,
    PocketCountVariant,
    pocketCountVariants,
    pocketTransition,
    PocketVariant,
    pocketVariants,
} from '../../../../TicksMeter.motion';
import { tokens } from '../../../../tokens';

interface StyledPocketProps {
    $active?: boolean;
}

export const StyledPocket = styled(motion.div).attrs({
    variants: pocketVariants,
    initial: PocketVariant.Hidden,
    animate: PocketVariant.Show,
    exit: PocketVariant.Hidden,
})<StyledPocketProps>`
    --yat_ticks-meter-pocket-color: ${({ $active }) => ($active ? color.eerie : color.white)};
    z-index: ${tokens.zIndex.pocket};
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: -${tokens.pocket.offset}px;
`;

export const Background = styled(motion.div).attrs({
    variants: pocketBackgroundVariants,
    transition: pocketTransition,
})`
    z-index: ${tokens.zIndex.status};
    position: absolute;
    width: 66%;
    height: 100%;
    background-color: ${color.cementWet};
    transform-origin: center right;
`;

export const Content = styled(motion.div).attrs({
    variants: pocketContentVariants,
    transition: pocketTransition,
})`
    z-index: ${tokens.zIndex.pocketContent};
    position: relative;
    display: grid;
    place-content: center;
    padding-right: 8%;
    height: 100%;
    // TODO: Consider aligning to the right of the <Tick />
    // align-content: center;
    // justify-content: end;
    // padding-right: 30%;
`;

export const Count = styled(motion.p).attrs({
    variants: pocketCountVariants,
    animate: PocketCountVariant.Update,
    transition: pocketCountTransition,
})`
    ${styledTypography.allianceBase};
    font-size: ${tokens.pocket.count.fontSize}px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
    color: var(--yat_ticks-meter-pocket-color);
`;
